import React from 'react'

import numeral from 'numeral'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { withStyles } from '@material-ui/core/styles'

import Typography from '@material-ui/core/Typography'
import ArrowDropDown from '@material-ui/icons/ArrowDropDown'

const styles = theme => ({
  root: {
    display: 'flex',
  },
  icon: {
    marginTop: -2,
  },
  positiveIcon: {
    transform: 'scaleY(-1)',
    color: theme.palette.success.main,
  },
  positiveText: {
    color: theme.palette.success.main,
  },
  negativeIcon: {
    color: theme.palette.error.main,
  },
  negativeText: {
    color: theme.palette.error.main,
  },
  neutralIcon: {
    display: 'none',
  },
  neutralText: {
    color: theme.palette.primary.main,
  },
})

const getClassName = (percentage) => {
  if (percentage === 0) {
    return 'neutral'
  } else if (percentage < 0) {
    return 'negative'
  }
  return 'positive'
}

const getPercentage = (old, current) => {
  if (old === 0 && current > 0) {
    return numeral(100)
  } else if (current === 0 && old > 0) {
    return numeral(-100)
  } else if (current === 0 && old === 0) {
    return numeral(0)
  }
  return numeral(((current - old) / old) * 100)
}

const ChangePercentage = ({
  classes, className, old, current 
}) => {
  const percentage = getPercentage(old, current)
  const percentClassName = getClassName(percentage.value())

  return (
    <div className={classNames(classes.root, className)}>
      <ArrowDropDown
        className={classNames(classes.icon, classes[`${percentClassName}Icon`])}
      />
      <Typography className={classes[`${percentClassName}Text`]}>
        {percentage.format('0,0.0')}%
      </Typography>
    </div>
  )
}

ChangePercentage.propTypes = {
  old: PropTypes.number,
  current: PropTypes.number,
  classes: PropTypes.object,
  className: PropTypes.string,
}

export default withStyles(styles)(ChangePercentage)



// WEBPACK FOOTER //
// ./src/components/atoms/ChangePercentage.js